import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreateClassHomePageDataService=async(data)=>{
    try {
        const result = await publicPost(`api/class_home_page_data/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateClassHomePageDataService=async(data,id)=>{
    try {
        const result = await put(`api/class_home_page_data/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClassHomePageDataService=async()=>{
    try {
        const result = await get(`api/class_home_page_data/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteClassHomePageDataService=async(id)=>{
    try {
        const result = await deleteRequest(`api/class_home_page_data/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

